import { Component } from '@angular/core';

@Component({
  selector: 'app-common-bottom-toolbar',
  templateUrl: './common-bottom-toolbar.component.html',
  styleUrl: './common-bottom-toolbar.component.scss',
  standalone: false,
})
export class CommonBottomToolbarComponent {}
